import './layout.css';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import Aside from '../aside/Aside';
import Footer from '../footer/Footer';
import Header from '../header/Header';
import ReactFocusLock from 'react-focus-lock';

const Layout = ({
    listaMenu,
    titulo,
    children,
    onKeyDown
}) => {

    const pathLocation = useLocation();

    const [isMenuOpen, setIsMenuOpen] = useState(false);

    const [menu, setMenu] = useState({
        larguraDoMenu: '66px',
        exibirEmpresa: 'none',
        exibirTexto: 'none',
        validarMenu: false
    });

    const abrirEFecharMenu = () => {
        setIsMenuOpen(prev => {
            const novoEstado = !prev;
            setMenu({
                larguraDoMenu: novoEstado ? '300px' : '66px',
                exibirEmpresa: novoEstado ? 'flex' : 'none',
                exibirTexto: novoEstado ? 'flex' : 'none',
                validarMenu: novoEstado
            });
            return novoEstado;
        });
    };

    useEffect(() => {
        setIsMenuOpen(false);
        setMenu({
            larguraDoMenu: '66px',
            exibirEmpresa: 'none',
            exibirTexto: 'none',
            validarMenu: false
        });
    }, [pathLocation]);

    return (
        <ReactFocusLock>
            <div className='template' onKeyDown={onKeyDown}>
                <div
                    className={`aside-backdrop ${isMenuOpen ? 'ativo' : ''}`}
                    onClick={abrirEFecharMenu}
                    aria-hidden='true'
                />
                <Aside
                    listaMenu={listaMenu}
                    larguraDoMenu={menu.larguraDoMenu}
                    visibilidadeDoMenu={menu.exibirEmpresa}
                    exibirEOcultarTexto={menu.exibirTexto}
                    isMenuOpen={isMenuOpen}
                    click={abrirEFecharMenu}
                />
                <Header
                    titulo={titulo}
                    isMenuOpen={isMenuOpen}
                    onToggleMenu={abrirEFecharMenu}
                />
                <main className='main'>
                    {children}
                </main>
                <Footer />
            </div>
        </ReactFocusLock>
    );
};

export default Layout;
